import { apiClient } from '../_helpers';
const apiPath = 'recipeSocials/';

export const socialService = {
    getSocials,
    add,
    remove
};
async function getSocials(id) {
    try {
        const response = await apiClient(apiPath)
            .get(`${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}
async function add(payload) {
    try {
        const response = await apiClient(apiPath)
            .post('', `${JSON.stringify(payload)}`);
        return response.data;
    } catch (error) {
        return error;
    }
}
async function remove(id) {
    try {
        const response = await apiClient(apiPath)
            .delete(`${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}